import { useEffect } from "react";

interface Props {
  dirty: boolean;
  onDirtyChange: (dirty: boolean) => void;
}

export function FormikDirtyTracker(props: Props) {
  const { dirty, onDirtyChange } = props;

  useEffect(() => {
    onDirtyChange(dirty);
  }, [dirty, onDirtyChange]);

  return null;
}
